import React from 'react';
import _ from 'lodash';

import {
	WithStyles,
	Theme,
	createStyles,
	withStyles
} from '@material-ui/core';
import {
	RadioButtonChecked as RadioIcon,
	CheckBox as CheckboxIcon,
	CalendarToday as DatePickerIcon,
	KeyboardArrowDown as DropdownIcon,
} from '@material-ui/icons';

const styles = (theme: Theme) => createStyles({
	tagPreviewWrapper: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		display: 'flex',
		alignItems: 'flex-end',
		width: '100%',
		padding: '4px 6px',
		justifyContent: 'space-between',
		'& > *': {
			display: 'inline-block',
		},
		'& > span': {
			...theme.typography.body2,
			fontWeight: theme.typography.fontWeightRegular,
		}
	},
	imgMargin:{
		margin: '2px 0 3px'
	},
	checkboxIcon: {
		color: theme.palette.primary.main,
	},
	radioIcon: {
		color: theme.palette.primary.main,
	},
	label: {
		paddingLeft: 14,
		flex: 1
	},
	mbXS: {
		marginBottom: 1
	}
});

interface TagPreviewProps extends WithStyles<typeof styles> {
	tagType: string,
	width: any,
}

export const RadioOptionsPreview = ({ classes }: any) => (
	<>
		<RadioIcon className={classes.radioIcon} />
		<span className={classes.label}>Compulsory</span>
	</>
)

export const CheckboxOptionsPreview = ({ classes }: any) => (
	<>
		<CheckboxIcon className={classes.checkboxIcon} />
		<span className={classes.label}>Compulsory</span>
	</>
);

export const DropdownMultiSelectPreview = ({ classes }: any) => (
	<>
		<CheckboxIcon className={classes.checkboxIcon} />
		<span>Option</span>
		<DropdownIcon />
	</>
)

export const DropdownSelectPreview = () => (
	<>
		<span>Option</span>
		<DropdownIcon />
	</>
)
export const SearchabelDropDown =  ({ classes }: any) => (
	<>
		<img className={classes.imgMargin} src="/assets/svg/myLibrary/search-icon.svg" alt="Search" />
		<span className={classes.label}>Search</span>
		{/* <DropdownIcon /> */}
	</>
)
export const DatePickerPreview = ({ classes }: any) => (
	<>
		<img className={classes.mbXS} src="/assets/svg/date.svg" alt="text" />
		<span className={classes.label}>dd / mm / yy</span>
	</>
)

export const TextInputPreview = ({ classes }: any) => (
	<>
		<img className={classes.mbXS} src="/assets/svg/text-field-icon.svg" alt="text" />
		<span className={classes.label}>Text Field</span>
	</>
)

const TagPreview = (props: TagPreviewProps) => {
	const { classes, tagType, width } = props;
	return (
		<div className={classes.tagPreviewWrapper} style={{ 'width': width }}>
			{_.includes(['radioOptions'], tagType) && <RadioOptionsPreview classes={classes} />}
			{_.includes(['checkboxOptions'], tagType) && <CheckboxOptionsPreview classes={classes} />}
			{_.includes(['datepicker'], tagType) && <DatePickerPreview classes={classes} />}
			{_.includes(['listpickerMultiselect'], tagType) && <DropdownMultiSelectPreview classes={classes} />}
			{_.includes(['listpicker'], tagType) && <DropdownSelectPreview />}
			{_.includes(['searchDropdown'], tagType) && <SearchabelDropDown classes={classes} />}
			{_.includes(['text', 'textLonginput'], tagType) && <TextInputPreview classes={classes} />}
		</div>
	);
};

export default withStyles(styles)(TagPreview);